const OrgTypes = ['university', 'bootcamp', 'recruiter', 'group'];

/**
 * Orgs whose members have access to AI features
 * @type {object}
 */
const AIOrgAllowList = {
  cbs: true,
  exponent: true,
  ivey: true,
  'social-continent': true,
  stanford: true,
  'uga-terry': true,
  yale: true,

  // Bootcamps that we grandfathered in before restricting bootcamp AI access
  codeplatoon: true,
};

/**
 * Orgs whose members should not see job referral features
 * @type {object}
 */
const JobReferralOrgDenyList = {
  insead: true,
};

/**
 * Orgs whose members should not receive promotional offers in subscription emails
 * @type {object}
 */
const PromotionOrgDenyList = {
  columbia: true,
  gatech: true,
};

/**
 * Email domains whose personal-account signups are offered their org's SSO login
 * @type {object}
 */
const OrgSignupCaptureDomains = {
  'cornell.edu': {name: 'Cornell', image: '/images/schools/cornell.png', link: '/login/saml/cornell'},
  'wharton.upenn.edu': {name: 'Wharton', link: '/login/saml/wharton'},
  'hbs.edu': {name: 'Harvard Business School', image: '/images/schools/hbs.png', link: '/login/saml/hbs'},
};

module.exports = {
  OrgTypes,
  AIOrgAllowList,
  JobReferralOrgDenyList,
  PromotionOrgDenyList,
  OrgSignupCaptureDomains,
};
